document.addEventListener(
    "DOMContentLoaded", () => {
        // General load more button
        const loadMoreButton = document.querySelector('.api-list-more .btn');
        if (loadMoreButton) {
            const loadMoreHandler = (event) => {
                event.preventDefault();
                // Get the current page from the button's data attribute
                const apiList = document.querySelector('.api-list');
                const currentPage = parseInt(apiList.dataset.listPage) || 0;
                const nextPage = currentPage + 1;
                apiList.dataset.listPage = nextPage;

                UpdateArticles();
            };
            loadMoreButton.addEventListener('click', loadMoreHandler);
        }

        function UpdateArticles() {

            const apiList = document.querySelector('.api-list');
            const page = apiList ? apiList.dataset.listPage || 0 : 0;

            // Get the overlay and hide it if it is now a full reset.
            const overlay = document.querySelector('.overlay');
            overlay.classList.add('active');

            // Get all the variables for the request
            var pagerUrl = apiList.getAttribute("data-search-url");
            var listUrl = apiList.getAttribute("data-list-url");
            var listPage = apiList.getAttribute("data-list-page");
            var listPageSize = apiList.getAttribute("data-list-pagesize");
            var listCount = apiList.getAttribute("data-list-count");

            // Create the request string
            var url = listUrl + "?api=true&filtered=true" +
                (listPage > 0 ? "&page=" + listPage : "") +
                (listPageSize > 0 ? "&pagesize=" + listPageSize : "");

            const response = fetch(url)
                .then((response) => {
                    return response.text();
                })
                .then((data) => {
                    // Get the bounding container for the full listing panel including filters.
                    const listingContainer = document.querySelector('.api-list');

                    listingContainer.innerHTML += data;

                    // Check to see if we have reached the max number of items to load, if we have then hide the load more button, if not then show it.
                    // Parse the HTML string into a document
                    const parser = new DOMParser();
                    const doc = parser.parseFromString(data, 'text/html');

                    // Find the element and get the attribute
                    const countUpdateElem = doc.querySelector('.articles-list-count-update');
                    const maxReached = countUpdateElem ? countUpdateElem.getAttribute('data-list-max') : null;

                    const apiListMore = document.querySelector(".api-list-more"); // Pager for the list
                    if (apiListMore) {
                        if (maxReached) {
                            apiListMore.style.display = 'none';
                        } else {
                            apiListMore.style.display = 'flex';
                        }
                    }

                    // Remove the active class on the overlay. Get the overlay again, just in case
                    const overlay = document.querySelector('.overlay');
                    if (overlay) {
                        overlay.classList.remove('active');
                    }
                });
        }
});


